// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1WrMg","itemTitle":"ClientEmergencyInfo_itemTitle__MYzbi","itemText":"ClientEmergencyInfo_itemText__1qS4N"};